import React from 'react';
import { KeyRound, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import CodeInput from '@/components/twofactor/CodeInput';

export default function ChallengeForm({ code, onCodeChange, useBackup, onToggleBackup, submitting, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="totp-challenge-form">
      <div className="space-y-2">
        <Label className="text-slate-300">{useBackup ? 'Recovery code' : 'Authenticator code'}</Label>
        <CodeInput code={code} onChange={onCodeChange} useBackup={useBackup} />
      </div>
      <Button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-500" disabled={submitting || code.length < (useBackup ? 8 : 6)} data-testid="totp-verify-submit">
        {submitting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <KeyRound className="mr-2 h-4 w-4" />}
        Verify
      </Button>
      <button type="button" onClick={onToggleBackup} className="w-full text-center text-sm text-indigo-400 hover:text-indigo-300" data-testid="toggle-backup-code">
        {useBackup ? 'Use authenticator app instead' : 'Use a recovery code instead'}
      </button>
    </form>
  );
}
